import React from 'react'

import { Badge } from '@cmsgov/design-system'

import { MessageList } from '../MessageList/MessageList'
import { useTranslation } from 'react-i18next'

// redux
import { useSelector, useDispatch } from 'react-redux'
import {
  getUnreadMessageCount,
  getAllMessages,
  markMessagesAsRead
} from '../../redux/reducers/messages'
import { getUserLoggedInState } from '../../redux/reducers/users'

// Tealium
import { CATEGORIES } from '../../constants/analytics.json'
import events, { Event } from 'pubsub/events'

// import dummyMessages from '../../data/messages'
export interface MessageInboxProps {
  className?: string
  selectedMessageId?: string
  isInsideOfModal: boolean
  showMessageCount?: number
}

export const MessageInbox: React.FC<MessageInboxProps> = ({ isInsideOfModal, selectedMessageId, className, showMessageCount }) => {
  const isLoggedIn = useSelector(getUserLoggedInState)
  const messages = useSelector(getAllMessages)
  const count = useSelector(getUnreadMessageCount)
  const unreadMessages = messages.filter(message => !message.read)
  const readMessages = messages.filter(message => message.read)
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation('messageCenter')

  const numberOfReadMessagesToShow = showMessageCount ? (showMessageCount > unreadMessages.length ? showMessageCount - unreadMessages.length : 0) : readMessages.length
  const visibleUnreadMessages = showMessageCount ? unreadMessages.slice(0, showMessageCount) : unreadMessages
  const visibleReadMessages = showMessageCount ? readMessages.slice(0, numberOfReadMessagesToShow) : readMessages

  const onMarkAllAsReadClick = () => {
    const clickEvent: Event = {
      authenticated: isLoggedIn,
      text: t('mark all as read'),
      category: CATEGORIES.MESSAGES,
      element: 'link',
      messageSubject: '',
      messageStatus: '',
      eventName: isInsideOfModal ? 'message_center_my_messages_click' : 'message_center_dropdown_click',
      messageComponent: isInsideOfModal ? 'my messages' : 'dropdown',
      activity: 'Link Click',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: true,
      sendToCoreAPI: true,
      isMessageCenter: true
    }
    events.publish(clickEvent)

    // send a read event for each message that was unread when this happened
    messages.forEach((message) => {
      if (message.read === false) {
        const clickEventReadUnreadMessage: Event = {
          authenticated: isLoggedIn,
          text: message.subject,
          category: CATEGORIES.MESSAGES,
          element: 'link',
          messageSubject: message.subject,
          messageStatus: 'unread',
          eventName: 'message_center_message_modal_click',
          messageComponent: 'message modal',
          activity: 'Message read',
          url: window.location.href,
          language: i18n.language,
          title: document.title,
          sendToTealium: false,
          sendToCoreAPI: true,
          isMessageCenter: true,
          messageId: message.guid,
          profileId: message.profileId
        }
        events.publish(clickEventReadUnreadMessage)
      }
    }

    )

    const messageIds = messages.map((message) => {
      return message.guid
    })
    dispatch(markMessagesAsRead({ messageIds }))
  }
  const shouldShowReadMessagesSection = visibleReadMessages.length > 0 || readMessages.length === 0

  return (
    <div className={`${className}`} data-testid='message-inbox'>
      <MessageList
        selectedMessageId={selectedMessageId}
        key='Unread'
        messageType='Unread'
        className='ch-c-message__unread'
        header={(
          <span>
            <span className='ch-c-message__unread_text'>
              {t('Unread')}
            </span>
            {
              count > 0
                ? <Badge className='ch-c-badge ch-c-badge__orange ' variation='warn' data-testid='unread-badge'>{count}</Badge>
                : ''
            }
          </span>
        )}
        headerAction={(
          <button
            type='button'
            data-testid='mark-all-read-button'
            className='ds-c-button ds-c-button--transparent'
            style={{ marginRight: '-24px' }}
            onClick={onMarkAllAsReadClick}
          >
            {t('Mark all as read')}
          </button>
        )}
        messages={visibleUnreadMessages}
        emptyText={t('You have no unread messages')}
        isInsideOfModal={isInsideOfModal}
      />

      {
        shouldShowReadMessagesSection &&
          <MessageList
            selectedMessageId={selectedMessageId}
            key='Read'
            messageType='Read'
            className='ch-c-message__read'
            header={t('Read')}
            messages={visibleReadMessages}
            emptyText={t('You have no previously read messages')}
            isInsideOfModal={isInsideOfModal}
          />
      }
    </div>
  )
}
